
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 3a1 1 0 011 1 4 4 0 004 4 1 1 0 110 2 6 6 0 01-4-1.528V16a5 5 0 11-5-5 1 1 0 110 2 3 3 0 103 3V4a1 1 0 011-1z","fill":"#B1AFCD"}})])
          )
        }
      }
    